class AccessHubsController
  @requestCurrentPhoto: ->
    accessHubChannel.requestCurrentPhoto()

  @hideElement: (element) ->
    element.style.display = 'none'

module.exports = AccessHubsController
